import { default as indexio6ZYMC13yMeta } from "/app/apps/explorer-plus/pages/_circulating-supply/index.vue?macro=true";
import { default as indexpo5bQs8m5rMeta } from "/app/apps/explorer-plus/pages/_on-chain/analytics/index/account-wallet/index.vue?macro=true";
import { default as indexXmumD56GncMeta } from "/app/apps/explorer-plus/pages/_on-chain/analytics/index/network/index.vue?macro=true";
import { default as indexPby9xqfFn6Meta } from "/app/apps/explorer-plus/pages/_on-chain/analytics/index/overview/index.vue?macro=true";
import { default as indexQKUqYPFbcDMeta } from "/app/apps/explorer-plus/pages/_on-chain/analytics/index/revenue/index.vue?macro=true";
import { default as index3iNFbngqRlMeta } from "/app/apps/explorer-plus/pages/_on-chain/analytics/index/token/index.vue?macro=true";
import { default as indexKslOdONz7aMeta } from "/app/apps/explorer-plus/pages/_on-chain/analytics/index/transaction-gas/index.vue?macro=true";
import { default as index1G122ulMB1Meta } from "/app/apps/explorer-plus/pages/_on-chain/analytics/index/valuation/index.vue?macro=true";
import { default as index70fFT5Mb9LMeta } from "/app/apps/explorer-plus/pages/_on-chain/analytics/index.vue?macro=true";
import { default as indexuGzlYGMz2mMeta } from "/app/apps/explorer-plus/pages/content/index/[contentType]/[contentId]/index.vue?macro=true";
import { default as indexHxW24NNs5eMeta } from "/app/apps/explorer-plus/pages/content/index/[contentType]/index.vue?macro=true";
import { default as index9i3QvsmjkVMeta } from "/app/apps/explorer-plus/pages/content/index/index.vue?macro=true";
import { default as index5LK6Ti6nvZMeta } from "/app/apps/explorer-plus/pages/content/index.vue?macro=true";
import { default as index4eHH3fd16XMeta } from "/app/apps/explorer-plus/pages/defi-dashboard/index.vue?macro=true";
import { default as indexiLl020J4oDMeta } from "/app/apps/explorer-plus/pages/ecosystem/[projectId]/featured/[featuredId]/index.vue?macro=true";
import { default as index6GDzvhK4SBMeta } from "/app/apps/explorer-plus/pages/ecosystem/[projectId]/index.vue?macro=true";
import { default as indexWkF1kI0o92Meta } from "/app/apps/explorer-plus/pages/ecosystem/index.vue?macro=true";
import { default as indexnVyYIKx293Meta } from "/app/apps/explorer-plus/pages/index.vue?macro=true";
import { default as indexsghmT8F2k8Meta } from "/app/apps/explorer-plus/pages/profile/project/index.vue?macro=true";
import { default as index9YpcR9p65pMeta } from "/app/apps/explorer-plus/pages/profile/token/[tokenId]/index.vue?macro=true";
import { default as indexQpBxQM6F3HMeta } from "/app/apps/explorer-plus/pages/terms-of-service/index.vue?macro=true";
export default [
  {
    name: "_circulating-supply___ko",
    path: "/ko/_circulating-supply",
    component: () => import("/app/apps/explorer-plus/pages/_circulating-supply/index.vue").then(m => m.default || m)
  },
  {
    name: "_circulating-supply___en",
    path: "/_circulating-supply",
    component: () => import("/app/apps/explorer-plus/pages/_circulating-supply/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics___ko",
    path: "/ko/_on-chain/analytics",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index.vue").then(m => m.default || m),
    children: [
  {
    name: "_on-chain-analytics-index-account-wallet___ko",
    path: "account-wallet",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/account-wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-network___ko",
    path: "network",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/network/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-overview___ko",
    path: "overview",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/overview/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-revenue___ko",
    path: "revenue",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/revenue/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-token___ko",
    path: "token",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/token/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-transaction-gas___ko",
    path: "transaction-gas",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/transaction-gas/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-valuation___ko",
    path: "valuation",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/valuation/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "_on-chain-analytics___en",
    path: "/_on-chain/analytics",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index.vue").then(m => m.default || m),
    children: [
  {
    name: "_on-chain-analytics-index-account-wallet___en",
    path: "account-wallet",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/account-wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-network___en",
    path: "network",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/network/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-overview___en",
    path: "overview",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/overview/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-revenue___en",
    path: "revenue",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/revenue/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-token___en",
    path: "token",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/token/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-transaction-gas___en",
    path: "transaction-gas",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/transaction-gas/index.vue").then(m => m.default || m)
  },
  {
    name: "_on-chain-analytics-index-valuation___en",
    path: "valuation",
    component: () => import("/app/apps/explorer-plus/pages/_on-chain/analytics/index/valuation/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index5LK6Ti6nvZMeta?.name,
    path: "/ko/content",
    component: () => import("/app/apps/explorer-plus/pages/content/index.vue").then(m => m.default || m),
    children: [
  {
    name: "content-index-contentType-contentId___ko",
    path: ":contentType()/:contentId()",
    component: () => import("/app/apps/explorer-plus/pages/content/index/[contentType]/[contentId]/index.vue").then(m => m.default || m)
  },
  {
    name: "content-index-contentType___ko",
    path: ":contentType()",
    component: () => import("/app/apps/explorer-plus/pages/content/index/[contentType]/index.vue").then(m => m.default || m)
  },
  {
    name: "content-index___ko",
    path: "",
    component: () => import("/app/apps/explorer-plus/pages/content/index/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index5LK6Ti6nvZMeta?.name,
    path: "/content",
    component: () => import("/app/apps/explorer-plus/pages/content/index.vue").then(m => m.default || m),
    children: [
  {
    name: "content-index-contentType-contentId___en",
    path: ":contentType()/:contentId()",
    component: () => import("/app/apps/explorer-plus/pages/content/index/[contentType]/[contentId]/index.vue").then(m => m.default || m)
  },
  {
    name: "content-index-contentType___en",
    path: ":contentType()",
    component: () => import("/app/apps/explorer-plus/pages/content/index/[contentType]/index.vue").then(m => m.default || m)
  },
  {
    name: "content-index___en",
    path: "",
    component: () => import("/app/apps/explorer-plus/pages/content/index/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "defi-dashboard___ko",
    path: "/ko/defi-dashboard",
    component: () => import("/app/apps/explorer-plus/pages/defi-dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: "defi-dashboard___en",
    path: "/defi-dashboard",
    component: () => import("/app/apps/explorer-plus/pages/defi-dashboard/index.vue").then(m => m.default || m)
  },
  {
    name: "ecosystem-projectId-featured-featuredId___ko",
    path: "/ko/ecosystem/:projectId()/featured/:featuredId()",
    meta: indexiLl020J4oDMeta || {},
    component: () => import("/app/apps/explorer-plus/pages/ecosystem/[projectId]/featured/[featuredId]/index.vue").then(m => m.default || m)
  },
  {
    name: "ecosystem-projectId-featured-featuredId___en",
    path: "/ecosystem/:projectId()/featured/:featuredId()",
    meta: indexiLl020J4oDMeta || {},
    component: () => import("/app/apps/explorer-plus/pages/ecosystem/[projectId]/featured/[featuredId]/index.vue").then(m => m.default || m)
  },
  {
    name: "ecosystem-projectId___ko",
    path: "/ko/ecosystem/:projectId()",
    component: () => import("/app/apps/explorer-plus/pages/ecosystem/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: "ecosystem-projectId___en",
    path: "/ecosystem/:projectId()",
    component: () => import("/app/apps/explorer-plus/pages/ecosystem/[projectId]/index.vue").then(m => m.default || m)
  },
  {
    name: "ecosystem___ko",
    path: "/ko/ecosystem",
    component: () => import("/app/apps/explorer-plus/pages/ecosystem/index.vue").then(m => m.default || m)
  },
  {
    name: "ecosystem___en",
    path: "/ecosystem",
    component: () => import("/app/apps/explorer-plus/pages/ecosystem/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ko",
    path: "/ko",
    component: () => import("/app/apps/explorer-plus/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/apps/explorer-plus/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "profile-project___ko",
    path: "/ko/profile/project",
    component: () => import("/app/apps/explorer-plus/pages/profile/project/index.vue").then(m => m.default || m)
  },
  {
    name: "profile-project___en",
    path: "/profile/project",
    component: () => import("/app/apps/explorer-plus/pages/profile/project/index.vue").then(m => m.default || m)
  },
  {
    name: "profile-token-tokenId___ko",
    path: "/ko/profile/token/:tokenId()",
    component: () => import("/app/apps/explorer-plus/pages/profile/token/[tokenId]/index.vue").then(m => m.default || m)
  },
  {
    name: "profile-token-tokenId___en",
    path: "/profile/token/:tokenId()",
    component: () => import("/app/apps/explorer-plus/pages/profile/token/[tokenId]/index.vue").then(m => m.default || m)
  },
  {
    name: "terms-of-service___ko",
    path: "/ko/terms-of-service",
    component: () => import("/app/apps/explorer-plus/pages/terms-of-service/index.vue").then(m => m.default || m)
  },
  {
    name: "terms-of-service___en",
    path: "/terms-of-service",
    component: () => import("/app/apps/explorer-plus/pages/terms-of-service/index.vue").then(m => m.default || m)
  }
]